module.exports = __webpack_public_path__ + "static/media/rundll_1.207e0048.ico";